<template>
     <el-card class="box-card" style="width: 1300px;margin:80px auto 0;">

    <el-form
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        style="width:1000px;float:left;"
      >
          <!-- 循环后端给你的所有题 -->
        <div
          class="VSTD_box_item"
          v-for="(item, index) in question"
          :key="index"
        >
           <div v-if="item.index==1">
                <h5>
                      二.选择题
                </h5>
           </div>
           <div v-if="item.index==2" style="margin-top:20px;">
                <h5>
                      一.判断题
                </h5>
           </div>
          <div v-for="(item1,index) in item.list" :key="item1.id" class="VSTD_box_item_title">
          <!-- 题目的信息 -->
             <div style="margin-left:20px;">
                 <p style="font-weight: 700">
                  第{{ index + 1 }}题：{{ item1.title
                  }}<span>（{{ item1.score }}分）</span>
                </p>
                <el-radio-group v-if="item.index==1" v-model="ruleForm.resource[index]" @click.native="item1.showAn=true" style="margin-top:15px;">
                      <el-radio v-for="item2 in item1.answers" :key="item2.answerid" :label="item2">{{item2.sm}}.{{item2.answerdetail}}</el-radio>
                </el-radio-group>
                 <el-radio-group v-if="item.index==2" v-model="ruleForm.judge[index]" @click.native="item1.showAn=true" style="margin-top:15px;">
                      <el-radio v-for="item2 in item1.answers" :key="item2.answerid" :label="item2">{{item2.sm}}.{{item2.answerdetail}}</el-radio>
                </el-radio-group>
             </div>
          </div>
        </div>
        <!-- 提交函数  -->
       <el-form-item style="text-align: center">
          <el-button type="primary" @click="submitForm()">提交</el-button>
       </el-form-item>
       </el-form>
       <el-card class="box-card">
          <div style="width:200px;float:left;margin-bottom:20px;">
                <p style="text-align:center;font-size:16px;color:#409EFF;">答题卡</p>
                <div v-for="(item,index) in question" :key="index">
                <p v-if="item.index==2" style="margin-bottom:10px;margin-top:10px;">
                    <span style="color:green;">
                        一.判断题
                    </span>
                 </p>
                  <p v-if="item.index==1" style="margin-bottom:10px;margin-top:10px;">
                    <span style="color:green;">
                        二.单选题
                    </span>
                 </p>
                 <div style="dispaly:flex;">
                       <div v-for="(item1,index) in item.list" :key="item1.id" style="display:inline-block;">
                              <div class="dt_ridio" :class="item1.showAn?'show_da':''">{{index+1}}</div>
                       </div>
                 </div>
                  
                 
                 
                </div>
                    <p v-show="showScore" style="text-align:center;font-size:16px;color:red;">
                          得分{{score}}

                          <a href="javascript:;" style="margin-left:5px;" @click="goAnswerDetail()">查看详情</a>
                   </p>
          </div>
       </el-card>

  </el-card>
</template>

   

<script>


export default {
    data() {
        return {
           keys:"",
           id:"",
           question:[],
           ruleForm: {
               resource: [],	
                	judge:[],	
           },
           useranser:[],
           showScore:false,
           score:0,
        }
    },
    methods:{

    init() {
     this.$http
        .post("Exam/GetSearchList", {
          keys: this.keys,
          pageIndex: 1,
          pageSize: 20,
          id:this.id,
          action: "getexamxq",
        })
        .then((res) => {
            
          if (res.data.isok) {
           
               this.question = res.data.data
          }
        })
        .catch((err) => {})
    },
    //代理商提交答案
    submitForm(){
         
      
      const that  = this
        that.useranser = []
     
        that.ruleForm.judge.forEach((item)=>{
               that.useranser.push(item)
        })
           that.ruleForm.resource.forEach((item)=>{
               that.useranser.push(item)
        })
         that.question.forEach((item1)=>{
              item1.list.forEach((item2)=>{
                   item2.answers.forEach((item3)=>{
                        that.useranser.forEach((item4)=>{
                             if(item3==item4){
                                 item4.examid=item2.examid
                                 item4.score=item2.score
                              //    item4.sm=item2.sm
                                 item4.inserttime = item2.inserttime
                             }
                             //delete item4.sm 
                             //delete item4.answerdetail
                             //delete item4.isright
                        })
                   })
              })

         })

        that.$http.post("Exam/CommitAnswer",{ 
           useranswer: that.useranser
        }).then((res)=>{
            if(res.data.isok){
                 this.$message.success(res.data.message);
                 this.score = res.data.data
                 this.showScore = true
            }else{
              this.$message.warning(res.data.message);
            }
          //  
        }).catch((err)=>{})
        
       
    },
   //查询答案
   goAnswerDetail(){

        this.$router.push({path:'/answerdetail',query:{id:this.id}})
   }
    

    },
    created(){
         this.id = this.$route.query.id
         this.init()
    }
}
</script>


<style scoped>
  .VSTD_box_item_title{
    margin-top:10px;
  }
  .dt_ridio{
       border:1px solid #36d;
       display: inline-block;
       margin-right:5px;
       width:30px;
       height:30px;
       border-radius: 50%;
       text-align: center;
       line-height: 30px;
       font-size:15px;
       cursor: pointer;
  }
  .show_da{
    background-color:#36d;
    color:#fff;
  }
 
</style>


// WEBPACK FOOTER //
// src/components/Answer.vue